import React, { useState } from 'react';
import { Form, Input, Button, Tabs, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
// 保留你的Header组件
import Header from '../../components/Header';
import './index.css';

const { TabPane } = Tabs;

const Auth = ({ onLogin, onRegister, loggedInUser, onLogout }) => {
  const [activeTab, setActiveTab] = useState('login');
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  // 标签切换
  const handleTabChange = (key) => {
    setActiveTab(key);
    key === 'login' && loginForm.resetFields();
    key === 'register' && registerForm.resetFields();
  };

  // 登录提交
  const handleLogin = async (values) => {
    setIsLoading(true);
    try {
      if (!values.username) {
        message.error('请输入用户名');
        return;
      }
      if (!values.password || values.password.length < 6) {
        message.error('密码至少6位');
        return;
      }
      onLogin(values);
    } catch (err) {
      message.error('登录失败');
    } finally {
      setIsLoading(false);
    }
  };

  // 注册提交
  const handleRegister = async (values) => {
    setIsLoading(true);
    try {
      if (!values.username) {
        message.error('请输入用户名');
        return;
      }
      if (!values.email) {
        message.error('请输入邮箱');
        return;
      }
      if (!values.password || values.password.length < 6) {
        message.error('密码至少6位');
        return;
      }
      onRegister(values);
    } catch (err) {
      message.error('注册失败');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* 你的Header组件（保持顶部导航样式） */}
      <Header 
        loggedInUser={loggedInUser} 
        onLogout={onLogout} 
      />

      {/* 表单区域（完整显示，匹配页面风格） */}
      <div className="auth-form-wrapper">
        <div className="auth-card">
          {/* 标题（匹配页面文字风格） */}
          <h2 className="auth-title">欢迎登录我的博客</h2>
          
          {/* 登录/注册标签（蓝色主题，与导航一致） */}
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="auth-tabs"
            centered
            tabBarActiveKey={{ color: '#1890ff' }}
          >
            <TabPane tab="登录" key="login" />
            <TabPane tab="注册" key="register" />
          </Tabs>

          {/* 登录表单 */}
          {activeTab === 'login' && (
            <Form
              form={loginForm}
              onFinish={handleLogin}
              layout="vertical"
              className="auth-form"
            >
              <Form.Item
                name="username"
                label="*用户名"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input 
                  prefix={<UserOutlined style={{ color: '#1890ff' }} />}
                  placeholder="请输入用户名"
                  className="auth-input"
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="*密码"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6位' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined style={{ color: '#1890ff' }} />}
                  placeholder="请输入密码"
                  className="auth-input"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={isLoading}
                  className="auth-btn"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          )}

          {/* 注册表单 */}
          {activeTab === 'register' && (
            <Form
              form={registerForm}
              onFinish={handleRegister}
              layout="vertical"
              className="auth-form"
            >
              <Form.Item
                name="username"
                label="*用户名"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input 
                  prefix={<UserOutlined style={{ color: '#1890ff' }} />}
                  placeholder="请输入用户名"
                  className="auth-input"
                />
              </Form.Item>
              <Form.Item
                name="email"
                label="*邮箱"
                rules={[
                  { required: true, message: '请输入邮箱' },
                  { type: 'email', message: '请输入有效邮箱' }
                ]}
              >
                <Input 
                  prefix={<MailOutlined style={{ color: '#1890ff' }} />}
                  placeholder="请输入邮箱"
                  className="auth-input"
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="*密码"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6位' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined style={{ color: '#1890ff' }} />}
                  placeholder="请输入密码"
                  className="auth-input"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={isLoading}
                  className="auth-btn"
                >
                  注册
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth;